import GravityAdapter from 'teacher-ui-client/adapters/gravity/v3-adapter'

export default class StandardsSetAdapter extends GravityAdapter {}
